import React, { Component } from 'react'
import { PropTypes } from 'prop-types'
import { connect } from 'react-redux'
import Page from '../../components/page'
import Header from '../../components/header'
import Wrapper from '../../components/wrapper'
import Title from '../../components/title'
import Footer from '../../components/footer'

import { css, withStyles } from '../../styles/withStyles'
import Styles from './styles'

class NotFound extends Component {
  constructor(props) {
    super(props)
  }

  render() {
    if (!this.globalStylesOverrides) {
      this.globalStylesOverrides = css(this.props.styles.globals)
    }

    return (
      <Page>
        <Header
          centeredLogo={true}
          whiteLabel={
            !!this.props.routing.locationBeforeTransitions.query.embedded
          }
        />
        <Wrapper>
          <Title
            title={'Pagina non trovata'}
            subtitle={
              'Ci dispiace, ma la pagina che stavi cercando di visualizzare non esiste.'
            }
          />
          <div {...css(this.props.styles.img)} />
        </Wrapper>
        <Footer />
      </Page>
    )
  }
}

NotFound.propTypes = {
  styles: PropTypes.object.isRequired
}

const mapStateToProps = (state /*, ownProps*/) => {
  return state
}

export default connect(mapStateToProps)(withStyles(Styles)(NotFound))



// WEBPACK FOOTER //
// ./containers/notFound/index.js